import { defineComponent as _defineComponent } from 'vue'
import BasicButton from '@/ui-components/BasicButton.vue';
import { SOCIAL_ICONS } from '@/constants/social-icons.constant';
import { useEditorialTracking } from '../tracking';


export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleSourceButton',
  setup(__props) {

const { trackEditorial } = useEditorialTracking();

const onVisibleCallback = {
	callback: (isVisible: boolean, entry: IntersectionObserverEntry) => {
		if (isVisible) trackEditorial('googleSourceImpression');
	},
};

function handleClick() {
	trackEditorial('clickGoogleSource');
}

return { __sfc: true,trackEditorial, onVisibleCallback, handleClick, BasicButton, SOCIAL_ICONS }
}

})